export const enAgentGuiSessionActions = {
  moreSessionActions: "More session actions",
  copiedToClipboard: "Copied",
  copyFailed: "Copy failed",
  copyAsMarkdown: "Copy as Markdown",
  copyAsReference: "Copy as reference",
  markSessionUnread: "Mark as unread",
  retryConversations: "Retry",
  conversationCopyImage: "Image",
  conversationCopyMentionPrefix: "@",
  conversationCopyFile: "File",
  conversationCopyPreviousMessages: "{{count}} previous messages",
  conversationCopyImagesOmitted:
    "{{count}} image(s) were too large to embed — right-click an image in the conversation to copy it separately",
  conversationCopyInProgress: "Copying conversation…",
  sessionActionUnavailable: "Session action is unavailable right now"
};
